import {Link} from 'gatsby'
import * as React from 'react'

import {TOP_NAVIGATION_HEIGHT} from '@/common/config'
import {Grid} from '@/components/Grid'
import {LanguageSwitcher} from '@/components/LanguageSwitcher'

const LoginIcon = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='12' cy='12' r='10' fill='#BEB4FF' />
    <circle cx='12' cy='10' r='3' fill='white' />
    <path
      d='M5.44141 19.5488C6.43484 16.8918 8.99662 15 12.0002 15C15.0039 15 17.5656 16.8918 18.5591 19.5488C16.8033 21.0756 14.5097 22 12.0002 22C9.49076 22 7.19718 21.0756 5.44141 19.5488Z'
      fill='white'
    />
  </svg>
)

const TopBar = ({loginLabel, loginLink}) => (
  <Grid className='relative'>
    <div
      className='body-xs-bold z-30 col-span-full flex items-center justify-end gap-4 py-1 text-white'
      style={{height: TOP_NAVIGATION_HEIGHT}}
    >
      <LanguageSwitcher />
      <div className='h-[24px] w-[1px] bg-[#BEB4FF]' />
      <div className='flex items-center gap-1'>
        <Link link={loginLink}>{loginLabel}</Link>
        <LoginIcon />
      </div>
    </div>
  </Grid>
)

export default TopBar
